import React, { useContext, useEffect, useState } from "react";
import AlertContext from "../Contexts/AlertContext";
import { authFileRequest, Authorized, fileRequest, props } from "../APIs/api";
import AuthContext from "../Contexts/AuthContext";
import AlertTypes from "../Enums/AlertTypes";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import NavContext from "../Contexts/NavContext";
import { useNavigate } from "react-router-dom";
import VerificationInput from "react-verification-input";
import { Login, loginWithTelebir } from "../APIs/AuthAPI";
import MainAPI from "../APIs/MainAPI";
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';


const ChangePassword = () => {

    const {currentOrder, updateCurrentOrder, openAlert, setWaiting, setShowAlert} = useContext(AlertContext);
    const {isLoggedIn, loggedUser, setLoggedUser, setLoggedIn, setCookie, cookies, removeCookie, authWaiting, localData} = useContext(AuthContext);
    const {selectNav} = useContext(NavContext);

    const navigate = useNavigate();
    const [passwordVisibility, setPasswordVisibility] = useState<Boolean>(false);
    const [confirmPasswordVisibility, setConfirmPasswordVisibility] = useState<Boolean>(false);
    const [oldPasswordVisibility, setOldPasswordVisibility] = useState<Boolean>(false);
    const [inputs, setInputs] = useState<any>({
        oldPassword: "",
        newPassword: "",
        confirmPassword: ""
    });

    useEffect(() => {

        // if(!isLoggedIn || !loggedUser) {
        //     navigate("/home"); (selectNav && selectNav("home"));
        // }

    }, []);

    const submitForm = async (event: any) => {
        event.preventDefault();

        try {

            if(inputs.newPassword == "" || inputs.confirmPassword != inputs.newPassword) {
                throw new Error("confirm password value should be the same as the new password.")
            }

            if(!inputs.oldPassword) {
                throw new Error("old password should be field.")
            }

            setTimeout(() => {setWaiting(true);}, 1);

            let response = await Authorized(cookies.login_token).bodyRequest("put", "crud/changePassword", {
                data: {
                    id: loggedUser.Id,
                    newPassword: inputs.newPassword,
                    oldPassword: inputs.oldPassword
                }
            });
            
            openAlert(AlertTypes.Success, <>Password changed successfully. <br />Use the new password on the next login unless you are using continue with telebirr.</>)

            navigate("/home");

        } catch (error: any) {
            openAlert(AlertTypes.Error, error.message);
        }

        setTimeout(() => {setWaiting(false);}, 1);

    }

    const inputChange = (event: any) => {
        setInputs((npt: any) => ({...npt, [event.target.name]: event.target.value}))
    }

    return (
        <div className="w-100 px-3 pt-3" style={{position: "relative"}}>
            <h1 className="card-title text-center mb-2">Change Password</h1>
            <p className="lead mb-5 text-center">
                Change your account password here. first enter the current password on the first field then enter your prefered new password then enter the same password as the new password to confirm.
            </p>

            <span className="card-title lead"><b><span className="text-danger">*</span> Current Password</b></span>
            <div className="nuwa-search-container mb-3 nuwa_panel d-flex" style={{padding: "10px", paddingRight: "5px"}}>
                <input type={oldPasswordVisibility ? "text" : "password"} name="oldPassword" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Old Password" />
                <button className="btn btn-sm" onClick={() => {setOldPasswordVisibility(!oldPasswordVisibility)}}>
                    {oldPasswordVisibility ? (<VisibilityOffIcon sx={{fontSize: "20px"}} />) : (<RemoveRedEyeIcon sx={{fontSize: "20px"}} />)}
                </button>
            </div>

            <span className="card-title lead"><b><span className="text-danger">*</span> New Password</b></span>
            <div className="nuwa-search-container mb-3 nuwa_panel d-flex" style={{padding: "10px", paddingRight: "5px"}}>
                <input type={passwordVisibility ? "text" : "password"} name="newPassword" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Create Password" />
                <button className="btn btn-sm" onClick={() => {setPasswordVisibility(!passwordVisibility)}}>
                    {passwordVisibility ? (<VisibilityOffIcon sx={{fontSize: "20px"}} />) : (<RemoveRedEyeIcon sx={{fontSize: "20px"}} />)}
                </button>
            </div>

            <span className="card-title lead"><b><span className="text-danger">*</span> Confirm Password</b></span>
            <div className="nuwa-search-container mb-4 nuwa_panel d-flex" style={{padding: "10px", paddingRight: "5px"}}>
                <input type={confirmPasswordVisibility ? "text" : "password"} name="confirmPassword" onChange={inputChange} className="nuwa-search-input w-100" placeholder="Confirm Password" />
                <button className="btn btn-sm" onClick={() => {setConfirmPasswordVisibility(!confirmPasswordVisibility)}}>
                    {confirmPasswordVisibility ? (<VisibilityOffIcon sx={{fontSize: "20px"}} />) : (<RemoveRedEyeIcon sx={{fontSize: "20px"}} />)}
                </button>
            </div>

            <button className="nuwa-white-btn py-2 px-2 text-center w-100" onClick={ submitForm } >
                Change Pssword
            </button>

        </div>
    );

};

export default ChangePassword;